<template>
  <div>
    <center>
      <vx-card class="min-h-screen">
        <div class="px-5 pb-5 relative" style="width: 900px">
          <div class="flex justify-between">
            <div></div>
            <div>
              <vs-button
                id="printPageButton"
                color="primary"
                type="gradient"
                icon-pack="feather"
                icon="icon-printer"
                @click="print()"
                class="ml-16 mb-5"
              >
                พิมพ์
              </vs-button>
            </div>
          </div>

          <div>
            <vx-card>
              <table>
                <tbody>
                  <tr>
                    <td>
                      <img
                        src="https://upload.wikimedia.org/wikipedia/th/0/01/%E0%B8%95%E0%B8%A3%E0%B8%B2%E0%B8%81%E0%B8%A3%E0%B8%A1%E0%B8%AA%E0%B8%A3%E0%B8%A3%E0%B8%9E%E0%B8%AA%E0%B8%B2%E0%B8%A1%E0%B8%B4%E0%B8%95.png"
                        alt
                        width="80px"
                        height="90px"
                      />
                    </td>
                    <td>
                      <center>
                        <h3>
                          โครงการเพิ่มประสิทธิภาพระบบควบคุม ตรวจสอบ
                          และติดตามการจำหน่ายน้ำมันดีเซล
                        </h3>
                        <h3>สำหรับชาวประมงในเขตต่อเนื่องของราชอาณาจักร</h3>
                      </center>
                    </td>
                  </tr>
                </tbody>
              </table>
              <h4 class="my-2">ความถี่การเข้ารับน้ำมันจากโรงกลั่น {{config.selectedRefinery.name}}</h4>
              <p>วันที่ {{setDateFormatTh(config.startDate)}} ถึง {{setDateFormatTh(config.endDate)}}</p>
            </vx-card>
          </div>

          <div
            class="vx-row mt-5 z-50"
            v-if="oilDistributions && oilDistributions.length != 0"
          >
            <div class="vx-col w-1/3" v-if="config.type != 'all'">
              <vx-card :style="config.type != 'all' ? 'height: 200px' : 'height: 250px'" class="text-left py-5 ">
                <p>ชื่อ : {{ vesselInfo.name_th }}</p>
                <p>ชื่อภาษาอังกฤษ : {{ vesselInfo.name }}</p>
                <p>MMSI : {{ vesselInfo.mmsi }}</p>
                <p>IMO : {{ vesselInfo.imo_number }}</p>
                <!-- <p>ความจุถัง : {{tanker.capacity ? formatNumber(tanker.capacity) : 0}}</p> -->
                <p>
                  ประเภทเรือ :
                  {{
                    vesselInfo.type == "tanker"
                      ? "สถานีบริการน้ำมัน"
                      : "เรือบรรทุกน้ำมัน"
                  }}
                </p>
              </vx-card>
            </div>
            <div :class="config.type != 'all' ? 'vx-col w-2/3' : 'vx-col w-full'">
              <vx-card :style="config.type != 'all' ? 'height: 200px' : 'height: 250px'">
                <!-- directree chart -->
                <DirectTree
                  :station="config.selectedRefinery"
                  :transferDataForDirectTree="oilDistributions"
                  :config="config"
                  :height="config.type != 'all' ? 180 : 230"
                />
              </vx-card>
            </div>
          </div>

          <div class="mt-5 z-0">
            <vx-card>
              <vs-table
                minHeight="500px"
                class="static text-center mt-3"
                :data="oilDistributions"
              >
                <template slot="header"> </template>
                <template slot="thead">
                  <vs-th class="tableInfo"><p class="mx-auto text-center">ลำดับ</p></vs-th>
                  <!-- <vs-th><p class="mx-auto text-center">เลขที่เอกสาร</p></vs-th> -->
                  <vs-th class="tableInfo" sort-key="departed_at_formatted_be"
                    ><p class="mx-auto text-center">วันที่ออกเดินทาง</p></vs-th
                  >
                  <vs-th class="tableInfo"><p class="mx-auto text-center">สถานีต้นทาง</p></vs-th>
                  <vs-th class="tableInfo"><p class="mx-auto text-center">ชื่อเรือ</p></vs-th>
                  <vs-th class="tableInfo"><p class="mx-auto text-center">เที่ยวที่</p></vs-th>
                  <!-- <vs-th><p class="mx-auto text-center">ประเภทน้ำมันที่ขน</p></vs-th> -->
                  <vs-th class="tableInfo"
                    ><p class="mx-auto text-center">
                      ปริมาตรน้ำมัน (ตามใบกำกับสินค้า)
                    </p></vs-th
                  >
                </template>
                <template slot-scope="{ data }">
                  <tbody>
                    <vs-tr
                      :data="tr"
                      :key="indextr"
                      v-for="(tr, indextr) in data"
                    >
                      <vs-td class="tableInfo">
                        {{ tr.index + 1 }}
                      </vs-td>

                      <vs-td class="tableInfo" :data="data[indextr].departed_at_formatted_be">
                        {{ data[indextr].departed_at_formatted_be }}
                      </vs-td>

                      <vs-td class="tableInfo" :data="data[indextr].station.name">
                        {{
                          data[indextr].station && data[indextr].station.name
                        }}
                      </vs-td>

                      <vs-td class="tableInfo" :data="data[indextr].vessel.name">
                        <a href="#" @click="tankerInfo(data[indextr].vessel)">
                          {{
                            data[indextr].vessel && data[indextr].vessel.name
                          }}
                        </a>
                      </vs-td>

                      <vs-td class="tableInfo" :data="data[indextr].trip_number">
                        {{ data[indextr].trip_number }}
                      </vs-td>

                      <vs-td class="tableInfo" :data="data[indextr].volume">
                        {{ data[indextr].volume }}
                      </vs-td>
                    </vs-tr>
                  </tbody>
                </template>
              </vs-table>
            </vx-card>
          </div>
        </div>
      </vx-card>
    </center>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import moment from "moment";
import { mapState } from "vuex";
import { REFINERY_NAME, REFINERY_ID } from "@/constants";
import { formatNumber } from "@/utils/index";
import DirectTree from "@/components/charts/Behavior/Refinery/DirectedTreeMonthlyOccurrence.vue";
import HighlightingChart from "@/components/charts/Behavior/Refinery/HighlightingChart.vue";

export default {
  components: {
    DirectTree,
    HighlightingChart,
  },
  data() {
    return {
      formatNumber,

      config: null,
      descriptionItems: [10, 25, 50, 100],
      vesselInfo: null,
      oilDistributions: [],
    };
  },
  watch: {
    oilDistributions(newVal, oldVal) {
      if (!_.isEqual(newVal, oldVal)) {
        for (const [index, oilDistribution] of newVal.entries()) {
          oilDistribution.index = index;
        }
      }
    },
  },
  async mounted() {
    this.config = JSON.parse(
      localStorage.getItem("configSearchBehaviorRefinery")
    );
    this.oilDistributions = JSON.parse(
      localStorage.getItem("oilDistributions")
    );
    this.vesselInfo = this.oilDistributions[0].vessel;

    console.log("this.config >> ", this.config);
  },
  methods: {
    setDateFormat(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    setDateFormatTh(date) {
      const locale = this.$i18n.locale;
      if (locale == "th") {
        const newDate = moment(date, "DD/MM/YYYY").add(543, "years").format("DD/MM/YYYY");
        return newDate;
      } else {
        const newDate = moment(date).format("DD/MM/YYYY");
        return newDate;
      }
    },
    setDateFormatRecordTime(date, type) {
      moment.locale("th"); // th
      if (type == "date") {
        const newDate = moment(date).add(543, "years").format("DD/MM/YYYY");
        return newDate;
      } else {
        const newTime = moment(date).format("LTS");
        return newTime;
      }
    },
    print() {
      window.print();
    },
  },
};
</script>

<style lang="css" scoped>
@page {
  /* size: landscape; */
  size: auto;
  margin: 0mm;
  background: white;
}
@media print {
  #printPageButton {
    display: none;
  }
}
.tableInfo {
  border: 1px solid rgb(194, 194, 194);
}
</style>
